import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "/maps/new-zealand-regions.geojson";

const REGIONS = [
    { code: "Northland", name: "Northland" },
    { code: "Auckland", name: "Auckland" },
    { code: "Waikato", name: "Waikato" },
    { code: "Bay of Plenty", name: "Bay of Plenty" },
    { code: "Gisborne District", name: "Gisborne" },
    { code: "Hawke's Bay", name: "Hawke's Bay" },
    { code: "Taranaki", name: "Taranaki" },
    { code: "Manawatu-Wanganui", name: "Manawatū-Whanganui" },
    { code: "Wellington", name: "Wellington" },
    { code: "Tasman District", name: "Tasman" },
    { code: "Nelson City", name: "Nelson" },
    { code: "Marlborough District", name: "Marlborough" },
    { code: "West Coast", name: "West Coast" },
    { code: "Canterbury", name: "Canterbury" },
    { code: "Otago", name: "Otago" },
    { code: "Southland", name: "Southland" },
    { code: "Chatham Islands Territory", name: "Chatham Islands" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const NewZealandMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 1300, center: [172, -41] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="new-zealand"
            analyticsLocationType="new_zealand"
            trackingLabel="New Zealand Map"
            storageKey="new-zealand_map"
            title="🇳🇿 New Zealand Travel Map"
            subtitle="Click on New Zealand regions you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="Regions"
            unitLabel="regions"
            captionUnit="New Zealand regions"
            share={{
                region: 'New Zealand',
                fileName: 'visited-new-zealand-map.png',
                trackId: 'new-zealand'
            }}
            renderMap={renderMap}
        />
    );
};

export default NewZealandMapSection;
